import { render, staticRenderFns } from "./BssList.vue?vue&type=template&id=4fa5a932&scoped=true&"
import script from "./BssList.vue?vue&type=script&lang=ts&"
export * from "./BssList.vue?vue&type=script&lang=ts&"
import style0 from "./BssList.vue?vue&type=style&index=0&id=4fa5a932&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fa5a932",
  null
  
)

export default component.exports